import React, {Fragment} from "react"
import moment from "moment"
import {retrieveSurvey} from "uprise-surveys/lib/surveys/index"

// UI
import {Accordian} from "@uprise/accordian"
import {Container, Row, Col} from "@uprise/grid"
import {Medium} from "@uprise/text"
import styled from "styled-components"
// Components
import {SurveyResult} from "./SurveyResult"

export const SurveyResults = ({results, tasks, custom = false}) => {
	const AccordianStyled = styled(Accordian)`
		& h4 {
			width: 100%;
			font-size: 16px;
			margin-top: 8px;
		}
	`

	const result = results.map((result, index) => {
		const taskId = result.taskId
		const survey = retrieveSurvey(result?.surveyId)
		const currentTask = tasks[taskId]

		const title = currentTask?.title || taskId
		const format = custom ? "DD/MM/YYYY" : "MMMM Do YYYY, h:mm:ss a"
		const date = moment.unix(result.timestamp).format(format)
		const summary = survey.getSummaryResults ? survey.getSummaryResults(result?.answers) : []

		const header = custom ? (
			<Row className='justify-content-between justify-items-center' style={{marginLeft: 0}}>
				<div>{title}</div>
				<Medium className='m-r-5'>{"Summary " + date}</Medium>
			</Row>
		) : (
			`${title} - ${date}`
		)

		if (summary.length) {
			return {
				header,
				content: <SurveyResult summary={summary} survey={survey} custom={custom} />
			}
		} else {
			return {
				header,
				content: "No data could be found"
			}
		}
	})

	return (
		<Fragment>
			{custom ? (
				<AccordianStyled className='m-b-5' content={result} />
			) : (
				<Accordian className='m-b-5' content={result} />
			)}
		</Fragment>
	)
}
